import React from 'react';

/**
 * Ulture icon set — a single inline-SVG family on a 24×24 grid,
 * round caps/joins, ~1.9 default stroke. Mirrors the production `UI` set.
 */
const GLYPHS = {
  home: 'M4 11.5 12 4l8 7.5|M6 10v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9|M10 20v-5h4v5',
  cal: 'rect:3.5,5,17,16,3|M3.5 9.5h17M8 3v4M16 3v4',
  calList: 'rect:3.5,5,17,16,3|M3.5 9.5h17M8 3v4M16 3v4M8 14h.01M8 17.5h.01M11.5 14h5M11.5 17.5h5',
  box: 'M12 3 20 7.3v9.4L12 21l-8-4.3V7.3L12 3Z|M4 7.3 12 12l8-4.7M12 12v9',
  mic: 'rect:9,3,6,11,3|M5.5 11.5a6.5 6.5 0 0 0 13 0M12 18v3M9 21h6',
  bug: 'ellipse:12,13,4,5|M12 8V5M9 6 7 4M15 6l2-2M8 13H5M19 13h-3M8.5 18 6 21M15.5 18 18 21|M9 10a3 3 0 0 1 6 0',
  flask: 'M9 3h6M10 3v6L5.7 17.6A2 2 0 0 0 7.5 20.5h9a2 2 0 0 0 1.8-2.9L14 9V3|M7.5 14h9',
  leaf: 'M5 19c0-8 6-13 14-13 0 8-5 14-13 14|M5 19c3-4 6-6 10-7',
  search: 'circle:11,11,6.5|m16 16 4.5 4.5',
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  check: 'm4 12.5 5 5 11-11',
  chevR: 'm9 6 6 6-6 6',
  chevL: 'm15 6-6 6 6 6',
  chevD: 'm6 9 6 6 6-6',
  arrowR: 'M5 12h14M13 6l6 6-6 6',
  gauge: 'M4 18a8 8 0 1 1 16 0|M12 18l4.5-5|dot:12,18,1.4',
  trash: 'M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13',
  edit: 'M14 5l5 5M4 20l1-4L16 5a2.1 2.1 0 0 1 3 3L8 19l-4 1Z',
  alert: 'M12 4 2.5 20h19L12 4Z|M12 10v4.5M12 17.6v.2',
  pulse: 'M2 12h4l3-8 4 16 3-8h6',
  gear: 'circle:12,12,3.2|M12 3v2.2M12 18.8V21M3 12h2.2M18.8 12H21M5.6 5.6l1.6 1.6M16.8 16.8l1.6 1.6M18.4 5.6l-1.6 1.6M7.2 16.8l-1.6 1.6',
  sliders: 'M5 7h14M5 17h14|circle:9,7,2.3|circle:15,17,2.3',
  filter: 'M3 5h18l-7 8v6l-4-2v-4L3 5Z',
  doc: 'M7 3h7l4 4v14H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z|M14 3v4h4M9 12h6M9 16h6',
  chart: 'M4 20V5M4 20h16M8 20v-6M12 20v-9M16 20v-4',
  clock: 'circle:12,12,9|M12 7v5l3.5 2',
  pin: 'M12 21s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12Z|circle:12,9,2.6',
  bolt: 'M13 3 4 14h7l-1 7 9-11h-7l1-7Z',
  euro: 'M17 7a6 6 0 1 0 0 10M5 10h8M5 14h8',
  users: 'circle:9,8,3.2|M3.5 19a5.5 5.5 0 0 1 11 0M16 6.2a3 3 0 0 1 0 5.6M17.5 19a5.5 5.5 0 0 0-2.5-4.6',
  user: 'circle:12,8,3.6|M5 20a7 7 0 0 1 14 0',
  building: 'rect:5,3,14,18,1.5|M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2',
  map: 'm9 4 6 2 5-2v14l-5 2-6-2-5 2V6l5-2Z|M9 4v14M15 6v14',
  drop: 'M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11Z',
  sun: 'circle:12,12,4|M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5 19 19M19 5l-1.5 1.5M6.5 17.5 5 19',
  temp: 'M10 14V5a2 2 0 1 1 4 0v9a4 4 0 1 1-4 0Z',
  rain: 'M7 16a4 4 0 0 1-.5-7.97 5.5 5.5 0 0 1 10.9.97A3.5 3.5 0 0 1 17 16M8 19l-1 2M12 19l-1 2M16 19l-1 2',
  refresh: 'M21 12a9 9 0 1 1-3-6.7M21 4v4h-4',
  camera: 'rect:3,7,18,13,3|circle:12,13.5,3.4|M8 7l1.5-2.5h5L16 7',
  send: 'M4 12 20 4l-6 16-3.5-6.5L4 12Z',
  x: 'M6 6l12 12M18 6 6 18',
  back: 'M11 5 4 12l7 7M4 12h16',
  list: 'M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01',
  layers: 'm12 3 9 5-9 5-9-5 9-5ZM3 13l9 5 9-5',
  target: 'circle:12,12,8|circle:12,12,3.4',
  eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z|circle:12,12,3',
  star: 'm12 3.5 2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L3.5 9.7l5.9-.9L12 3.5Z',
  bell: 'M6 9a6 6 0 1 1 12 0c0 5 2 6 2 6H4s2-1 2-6M10 20a2 2 0 0 0 4 0',
  health: 'M12 20s-7-4.5-7-9.5A4 4 0 0 1 12 7a4 4 0 0 1 7 3.5c0 1.2-.4 2.3-1 3.4|M8.5 13h2l1.2-2.2L14 15l1-2h3.5',
  spark: 'M12 3c.6 3.7 2.3 5.4 6 6-3.7.6-5.4 2.3-6 6-.6-3.7-2.3-5.4-6-6 3.7-.6 5.4-2.3 6-6Z|M18.5 14.5c.25 1.5.95 2.2 2.5 2.5-1.55.3-2.25 1-2.5 2.5-.25-1.5-.95-2.2-2.5-2.5 1.55-.3 2.25-1 2.5-2.5Z',
  download: 'M12 3v12M7 11l5 5 5-5M5 21h14',
  play: 'M7 5l11 7-11 7Z',
  flag: 'M5 21V4M5 4h12l-2 4 2 4H5',
  mail: 'rect:3,5,18,14,3|m4 7 8 6 8-6',
  card: 'rect:3,5,18,14,3|M3 10h18',
  hat: 'M12 4 2 9l10 5 10-5-10-5ZM6 11v5c0 1.5 2.7 3 6 3s6-1.5 6-3v-5',
  grid: 'rect:4,4,6.5,6.5,1.5|rect:13.5,4,6.5,6.5,1.5|rect:4,13.5,6.5,6.5,1.5|rect:13.5,13.5,6.5,6.5,1.5',
  globe: 'circle:12,12,9|M3 12h18M12 3c2.6 2.4 4 5.6 4 9s-1.4 6.6-4 9c-2.6-2.4-4-5.6-4-9s1.4-6.6 4-9Z',
  ruler: 'rect:3,8,18,8,1.5|M7 8v3M11 8v4M15 8v3M19 8v4',
  dots: 'dot:5,12,1.6|dot:12,12,1.6|dot:19,12,1.6',
  dotsV: 'dot:12,5,1.6|dot:12,12,1.6|dot:12,19,1.6',
};

function renderToken(tok, color) {
  if (tok.startsWith('rect:')) {
    const [x, y, w, h, r] = tok.slice(5).split(',');
    return <rect key={tok} x={x} y={y} width={w} height={h} rx={r} />;
  }
  if (tok.startsWith('circle:')) {
    const [cx, cy, r] = tok.slice(7).split(',');
    return <circle key={tok} cx={cx} cy={cy} r={r} />;
  }
  if (tok.startsWith('ellipse:')) {
    const [cx, cy, rx, ry] = tok.slice(8).split(',');
    return <ellipse key={tok} cx={cx} cy={cy} rx={rx} ry={ry} />;
  }
  if (tok.startsWith('dot:')) {
    const [cx, cy, r] = tok.slice(4).split(',');
    return <circle key={tok} cx={cx} cy={cy} r={r} fill={color} stroke="none" />;
  }
  return <path key={tok} d={tok} />;
}

export function Icon({ name, size = 22, color = 'currentColor', stroke = 1.9, style, ...rest }) {
  const def = GLYPHS[name];
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: 'block', flexShrink: 0, ...style }}
      aria-hidden={!rest['aria-label']}
      {...rest}
    >
      {def ? def.split('|').map((t) => renderToken(t, color)) : null}
    </svg>
  );
}

/** The full list of available icon names (handy for pickers / specimen cards). */
export const ICON_NAMES = Object.keys(GLYPHS);
